import React, {
    useEffect,
    useState
} from "react";

import {
    FaTimes
} from "react-icons/fa";

import API_BASE_URL from "../config/config";

import "./PopupGallery.css";


const PopupGallery = () => {

    const [popupImage, setPopupImage] =
        useState(null);

    const [showPopup, setShowPopup] =
        useState(false);

    const [loading, setLoading] =
        useState(true);


    // =========================================================
    // API URL
    // =========================================================

    const API_URL =
        API_BASE_URL.replace(/\/$/, "");


    // =========================================================
    // STORAGE BASE URL
    // =========================================================

    const STORAGE_BASE_URL =
        API_URL.replace(/\/api$/, "");


    // =========================================================
    // GET IMAGE URL
    // =========================================================

    const getImageUrl = (image) => {

        if (!image) {
            return "";
        }

        if (
            image.startsWith("http://") ||
            image.startsWith("https://")
        ) {
            return image;
        }

        return `${STORAGE_BASE_URL}/storage/gallery/${image.replace(
            /^\/+/,
            ""
        )}`;
    };


    // =========================================================
    // FETCH RANDOM POPUP IMAGE
    // =========================================================

    const fetchPopupImage = async () => {

        try {

            setLoading(true);

            const response =
                await fetch(
                    `${API_URL}/user-gallery-popup`
                );

            const data =
                await response.json();

            console.log(
                "POPUP GALLERY:",
                data
            );


            if (
                response.ok &&
                data.success &&
                data.data
            ) {

                setPopupImage(data.data);

                setShowPopup(true);

                // Mark popup as already shown
                localStorage.setItem(
                    "home_popup_gallery_shown",
                    "true"
                );
            }

        } catch (error) {

            console.error(
                "POPUP GALLERY ERROR:",
                error
            );

        } finally {

            setLoading(false);
        }
    };


    // =========================================================
    // LOAD ONLY ONE TIME
    // =========================================================

    useEffect(() => {

        const alreadyShown =
            localStorage.getItem(
                "home_popup_gallery_shown"
            );


        if (alreadyShown === "true") {

            setLoading(false);

            return;
        }


        fetchPopupImage();


    }, []);


    // =========================================================
    // CLOSE POPUP
    // =========================================================

    const closePopup = () => {

        setShowPopup(false);

        localStorage.setItem(
            "home_popup_gallery_shown",
            "true"
        );
    };


    // =========================================================
    // ESC KEY
    // =========================================================

    useEffect(() => {

        const handleEscape = (event) => {

            if (
                event.key === "Escape" &&
                showPopup
            ) {
                closePopup();
            }
        };


        document.addEventListener(
            "keydown",
            handleEscape
        );


        return () => {

            document.removeEventListener(
                "keydown",
                handleEscape
            );

        };

    }, [showPopup]);


    // =========================================================
    // BODY SCROLL LOCK
    // =========================================================

    useEffect(() => {

        if (showPopup) {

            document.body.style.overflow =
                "hidden";

        } else {

            document.body.style.overflow =
                "";
        }


        return () => {

            document.body.style.overflow =
                "";

        };

    }, [showPopup]);


    // =========================================================
    // DON'T RENDER
    // =========================================================

    if (
        loading ||
        !showPopup ||
        !popupImage
    ) {
        return null;
    }


    return (

        <div
            className="popup-gallery-overlay"
            onClick={closePopup}
        >

            <div
                className="popup-gallery-modal"
                onClick={(event) =>
                    event.stopPropagation()
                }
            >

                {/* =========================================
                    CLOSE BUTTON
                ========================================= */}

                <button
                    type="button"
                    className="popup-gallery-close"
                    onClick={closePopup}
                    aria-label="Close popup"
                >
                    <FaTimes />
                </button>


                {/* =========================================
                    TOP DECORATION
                ========================================= */}

                <div className="popup-gallery-top-line">
                    <span></span>
                    <i></i>
                    <span></span>
                </div>


                {/* =========================================
                    IMAGE
                ========================================= */}

                <div className="popup-gallery-image-wrapper">

                    <img
                        src={getImageUrl(
                            popupImage.image
                        )}
                        alt={
                            popupImage.title ||
                            "Gallery"
                        }
                        className="popup-gallery-image"
                    />

                </div>


                {/* =========================================
                    OPTIONAL TITLE
                ========================================= */}

                {popupImage.title && (

                    <div className="popup-gallery-content">

                        <h3>
                            {popupImage.title}
                        </h3>

                    </div>

                )}


                {/* =========================================
                    BOTTOM DECORATION
                ========================================= */}

                <div className="popup-gallery-bottom-decoration">

                    <span></span>

                    <div>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    <span></span>

                </div>

            </div>

        </div>
    );
};


export default PopupGallery;